<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="vehicleBookings" class="vehicle-book-table" [lazy]="true" (onLazyLoad)="loadLazy($event)"
  dataKey="vehicleBookingId" selectionMode="single" [(selection)]="vehicleBooking" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]"
  showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped"
  [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center titleblue">
      <h4 style="float: left;margin: 6px;">Vehicle Bookings</h4>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined"
          (click)="onOpenFormAdd()">New Vehicle Booking +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple [class.small-btn]="reservationId" (click)="onOpenFormAdd()">New Vehicle
          Booking +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        @if (col.condition) {
          <th [ngStyle]="{'width': 'auto'}">
            @if (col.sortable) {
              <span [pSortableColumn]="col.field">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </span>
            } @else {
              {{ col.header }}
            }
          </th>
        }
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [options]="vehicles" [dropdownIcon]="'fa fa-caret-down'" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Vehicle" [style]="{'width':'100%'}" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
          (onChange)="pt.filter($event.value, 'vehiclePref', 'in')"></p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'100%'}" pInputText type="text"
            (input)="pt.filter($event.target.value, 'agencyConfNumber', 'in')">
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'100%'}" pInputText type="number"
            (input)="pt.filter($event.target.value, 'retailUpgradeCostPerDay', 'in')">
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [options]="statuses" [dropdownIcon]="'fa fa-caret-down'" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Status" [style]="{'width':'100%'}" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
          (onChange)="pt.filter($event.value, 'bookingStatus', 'in')"></p-dropdown>
        </th>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'pickUpLocPref', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'dropOffLocPref', 'in')"></th> -->
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [style]="{'width':'120px'}" [options]="pickupDrops" [dropdownIcon]="'fa fa-caret-down'" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Location" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
            (onChange)="pt.filter($event.value, 'pickUpLocPref', 'in')">
          </p-dropdown>
          <!-- <input [ngStyle]="{'width':'180px','min-width':'150px','margin-top':'4px'}" pInputText type="datetime-local" placeholder="Date & Time"
          (input)="onPickUpDateTimeInput($event.target.value, pt)"> -->
          <input [ngStyle]="{'width':'180px','min-width':'150px','margin-top':'4px'}" pInputText
            type="date" (input)="pt.filter($event.target.value, 'pickUpDateTimePref', 'in')">
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [style]="{'width':'120px'}" [options]="pickupDrops" [dropdownIcon]="'fa fa-caret-down'" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Location" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
          (onChange)="pt.filter($event.value, 'dropOffLocPref', 'in')"></p-dropdown>
          <!-- <input [ngStyle]="{'width':'180px','min-width':'150px','margin-top':'4px'}" pInputText type="datetime-local" placeholder="Date & Time"
          (input)="onDropOffDateTimeInput($event.target.value, pt)"> -->
          <input [ngStyle]="{'width':'180px','min-width':'150px','margin-top':'4px'}" pInputText
            type="date" (input)="pt.filter($event.target.value, 'dropOffDateTimePref', 'in')">
        </th>
        @if (!reservationId) {
          <th [ngStyle]="{'width': 'auto'}"><input
            [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
          (input)="pt.filter($event.target.value, 'primaryDriverName', 'in')"></th>
        }
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'180px','min-width':'150px'}" pInputText type="datetime-local" placeholder="Cancel Date & Time"
            (input)="onDateTimeInput($event.target.value, pt, 'cancelDate')">
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <input [ngStyle]="{'width':'180px','min-width':'150px'}" pInputText type="datetime-local"
            placeholder="Created Date & Time" (input)="onDateTimeInput($event.target.value, pt, 'createDate')">
        </th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-vehicleBooking>
    <tr [pSelectableRow]="vehicleBooking">
      <td>{{getVehicleName(vehicleBooking.vehiclePref)}} </td>
      <td>{{vehicleBooking?.agencyConfNumber || '-'}}</td>
      <td>{{vehicleBooking?.retailUpgradeCostPerDay ? (vehicleBooking.retailUpgradeCostPerDay | currency:'USD':'symbol':'1.2-2') : '-'}}</td>
      <td>{{getStatusName(vehicleBooking?.bookingStatus)}}</td>
      <td>{{getPickupDropName(vehicleBooking.pickUpLocPref)}} - {{vehicleBooking.formattedPickUpDateTimePref}}</td>
      <td>{{getPickupDropName(vehicleBooking.dropOffLocPref)}} - {{vehicleBooking.formattedDropOffDateTimePref}}</td>
      @if (!reservationId) {
        <td>{{vehicleBooking.primaryDriverName}}</td>
      }
      <td>{{vehicleBooking.formattedCancelDate}}</td>
      <td>{{vehicleBooking.formattedCreatedDate}}</td>
      <td>
        <span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;"
            (click)="onOpenFormEdit(vehicleBooking)"></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>